import React from 'react'
import _ from "underscore";

// Logic, logic, logic

const Logic  = function(props){
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Logic' id='logic' iconclass='category with-icon-paths snap-icon-logic_dual'>
                <label text="Logic"/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Logic;